<template>
  <div>
    <v-list dense>
      <div v-for="m in authUser?.menu" :key="m.id">
        <MenuItem :item="m" v-if="m.children === undefined || !m.children?.length" />
        <v-list-group v-else :prepend-icon="m.icon">
            <template v-slot:activator>
                <v-list-item-title>{{ m.title }}</v-list-item-title>
            </template>
            <MenuItem v-for="child in m.children" :key="child.id" :item="child" />
        </v-list-group>
      </div>
      <RelatedApps/>
    </v-list>
  </div>
</template>

<script>
import { mapState } from "vuex";
import accionesMasivas from '../../modules/accionesMasivas';
import MenuItem from '@/components/menus/MenuItem';
import RelatedApps from './RelatedApps.vue';

export default {
  name: "AppMenu",
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
    drawer: null,
  }),
  methods: {
    mostrar(item) {
      // Por cada ruta de la aplicación, se verifica si está configurada para mostrarse en el menú de la aplicación (menú izquierdo)
      if (
        item.meta && item.meta.displayIn === "appMenu" && item.meta.parent === null && 
        this.tieneAcceso(item) || item.name === 'dashboard'
      ){
        return true;
      }
      return false;
    },
    // Verifica si el item del menu pasado existe en los componentes que tiene acceso el usuario
    tieneAcceso(menuItem){
      return this.authUser.componentes.some(componente => componente.componente_id === menuItem.meta.componenteId);
    }
  },
  computed: {
    ...mapState("login", ["authUser"]),
    accionesMasivas(){
      return this.$router.options.routes.filter(element => element.meta && element.meta.parent === 'accionesMasivas' && this.tieneAcceso(element));
    },
    packsYMantenimientos(){
      return this.$router.options.routes.filter(element => element.meta && element.meta.parent === 'packsMantenimientos' && this.tieneAcceso(element));
    }
  },
  mounted(){
    
  },
  components: {
    MenuItem,
    RelatedApps
  }
};
</script>

<style>
/* para editar el comportamiento on hover del listado */
/* .theme--light.v-list-item {
  -webkit-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
}
.theme--light.v-list-item:hover {
  background-color: #2196f3;
  border-radius: 0.4em;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-transform: translate(1em, 0);
  transform: translate(1em, 0);
} */
  /* .ai{
    background: linear-gradient(to right, rgb(0, 230, 230), blue);
    background-size: 180% 180%;
    -webkit-background-clip: text !important;
    background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    font-weight: bolder;
    animation: rainbow 4s ease infinite;
    -webkit-animation: rainbow 4s ease infinite;
  }
  @keyframes rainbow { 
    0% {background-position: 0% 0%;}
    50% {background-position: 100% 50%;}
    100% {background-position: 0% 50%;}
  } */
    .ai{
      animation: rainbow 4s linear infinite;
      background-image: linear-gradient(90deg,#00e6e6,#0059ff,#00e6e6,#0059ff);
      background-size: 300% 100%;
      -webkit-background-clip: text !important;
      background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      font-weight: bolder;
  }
  @keyframes rainbow { 
    0% { background-position: 100% 0%; }
    100% { background-position: 0% 0%; }
  }
</style>